<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-11 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createMoneda">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listMoneda != 0">
            <md-table md-card md-header v-model="listMoneda">
                <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editMoneda(item.id)">
                    <md-table-cell :md-label="labels.moneda" class="border text-left">{{ nameMoneda(item.moneda) }}</md-table-cell>
                    <md-table-cell :md-label="labels.vigencia" class="border text-left">{{ item.vigencia }}</md-table-cell>
                    <md-table-cell :md-label="labels.trm" class="border text-right">{{ item.trm }}</md-table-cell>
                    <md-table-cell :md-label="labels.trmPromedio" class="border text-right">{{ item.trm_promedio }}</md-table-cell>
                    <md-table-cell :md-label="labels.valorPropio" class="border text-right">{{ item.valor_propio }}</md-table-cell>
                </md-table-row>
            </md-table>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modCrearMoneda="showCrearMoneda" @cierraModal="closeModal"></Crear>
        <Editar :modEditarMoneda="showEditarMoneda" :infoMoneda="dataMoneda" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Moneda from '../../../services/Moneda';
import TipoMoneda from '../../../services/TipoMoneda';
import Crear from './Crear.vue';
import Editar from './Editar.vue';

export default {
    name : 'Moneda',
    components: {Crear,Editar},
    data : () => ({
        listMoneda : [],
        lstTipoMoneda : [],
        showCrearMoneda : false,
        showEditarMoneda : false,
        dataMoneda : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Moneda',
                    noRow : "No hay registros",
                    moneda : 'Moneda',
                    vigencia : 'Vigencia',
                    trm : 'TRM',
                    trmPromedio : 'TRM promedio',
                    valorPropio : 'Valor propio'
                }
            }else{
                return {
                    title : 'Currency',
                    noRow : "There are not records",
                    moneda : 'Currency',
                    vigencia : 'Validity',
                    trm : 'TRM',
                    trmPromedio : 'Average trm',
                    valorPropio : 'Self value'
                }
            }
        }
    },
    methods:{
        createMoneda(){
            this.showCrearMoneda = true
        },
        editMoneda(id){
            Moneda.getMonedaById(id)
            .then((res) => {
                this.dataMoneda = res.data.infoMoneda[0]
                this.showEditarMoneda = true
            })
            .catch((err) => console.log(err))
        },
        closeModal(val){
            this.showCrearMoneda = val
            this.showEditarMoneda = val
        },
        nameMoneda(moneda){
            let nombre = this.lstTipoMoneda.find((tipMoneda) => tipMoneda.moneda === moneda)
            return nombre.descripcion
        }
    },
    mounted(){
        Moneda.getAllMonedas()
        .then((res) => {
            // console.log(res.data.listMoneda);
            this.listMoneda = res.data.listMoneda
        })
        .catch((error) => console.log(error))

        TipoMoneda.getAllTipoMoneda()
        .then((res) => {
            // console.log(res.data);
            this.lstTipoMoneda = res.data.listTipoMoneda
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>